// extracted by mini-css-extract-plugin
module.exports = {"PDFViewer":"PDFViewer_PDFViewer__2plIl","pagination":"PDFViewer_pagination__1-ix5"};